import { render, staticRenderFns } from "./HomeSectionTitle.vue?vue&type=template&id=4544b30a"
import script from "./HomeSectionTitle.vue?vue&type=script&lang=js"
export * from "./HomeSectionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports